import {
  useSelectedNumberByVariableKey,
  useSelectedValueAttributeByKey,
  useSelectedValueByVariableKey,
  useSelectionByVariableKey,
} from '@k3/core'
import { useMeasures } from './useMeasures'
import { ColorRepresentation } from 'three'
import { isForbiddenValues } from './isForbiddenValues'
import { Keys } from './utlility/utils'
import { useSidewall } from './useSidewall'

export const useMarquee = () => {
  const {
    userWidth,
    polesTopNumber,
    attachment,
    offsetRoofLog,
    isQubus,
    verandaLogWidth,
    verandaTyp,
    eaves,
  } = useMeasures()

  const marqueeTyp = {
    hasUnderRoof: (useSelectedValueByVariableKey(Keys.Markise.Variable)?.key ===
      isForbiddenValues(Keys.Markise.Values.Unterdach)) as boolean,
    type: useSelectedValueByVariableKey(Keys.Markise.Variable)?.key,
    color: useSelectedValueByVariableKey('fabricColor')
      ?.value as ColorRepresentation,
    hasOverRoof: (useSelectedValueByVariableKey(Keys.Markise.Variable)?.key ===
      isForbiddenValues(Keys.Markise.Values.Aufdach)) as boolean,
    haslPlissee: (useSelectedValueByVariableKey(Keys.Markise.Variable)?.key ===
      isForbiddenValues(Keys.Markise.Values.Plissee)) as boolean,
    haslFabric: (useSelectedValueByVariableKey(Keys.Markise.Variable)?.key ===
      isForbiddenValues(Keys.Markise.Values.Stoff)) as boolean,
    hasIntergrateBox: (useSelectedValueByVariableKey(Keys.Markise.Variable)
      ?.key ===
      isForbiddenValues(Keys.Markise.Values.IntegrierteBox)) as boolean,
    hasNotShading:
      ((useSelectedValueByVariableKey(Keys.Markise.Variable)?.key ===
        isForbiddenValues(Keys.Markise.Values.Ohne)) as boolean) || true,
  }
  const space = isQubus ? userWidth - verandaLogWidth : userWidth

  const turningBox =
    ((useSelectedValueByVariableKey('turningBox')?.value === '1') as boolean) ||
    false

  const marqueeFabricColor = useSelectedValueByVariableKey('fabricColor')
    ?.value as ColorRepresentation

  const marqueeMaxLength =
    (useSelectedNumberByVariableKey('marqueeLength') as number) / 100.0 || 6

  const marqueeLength = space > marqueeMaxLength ? marqueeMaxLength : space

  const marqueeAmountComplete = Math.ceil(space / marqueeLength)

  const SpaceBetweenBar = space / (polesTopNumber - 1)

  const hasRoofBarCenter = polesTopNumber % 2 !== 0

  const hasSideWall = useSelectedNumberByVariableKey('hasMarqueeWinkel') || 0

  const marqueeCutWitdthSidewall =
    hasSideWall && marqueeTyp.hasUnderRoof ? verandaTyp.roofBar.depth * 2 : 0

  const marqueeStack: number[] = []

  const getMarqueePosition = (index: number, width: number) => {
    let pos = 0

    marqueeStack.forEach((value, i) => {
      let posSingle = 0
      for (let i = 0; i < index; i++) {
        posSingle += marqueeStack[i]
      }

      pos = posSingle
    })

    return [
      attachment.free ? 0 : 0,
      marqueeTyp.hasOverRoof
        ? offsetRoofLog.c
        : marqueeCutWitdthSidewall
        ? eaves
          ? 0
          : 0.03
        : 0,
      width / 2 + pos + marqueeCutWitdthSidewall / 2,
    ] as [number, number, number]
  }
  const maqrueeAttributes = {
    box: {
      width:
        (useSelectedValueAttributeByKey(
          Keys.Markise.Variable,
          'marqueeBoxWidth'
        )?.value as number) / 100 || 0,
    },
    height:
      (useSelectedValueAttributeByKey(Keys.Markise.Variable, 'height')
        ?.value as number) / 100 || 0.035,
    farbric: {
      depth:
        (useSelectedValueAttributeByKey(Keys.Markise.Variable, 'fabricDepth')
          ?.value as number) / 100 || 0,
    },
  }

  const checkMarqueeAmount = () => {
    if (marqueeAmountComplete <= 1) {
      marqueeStack.push(space - marqueeCutWitdthSidewall)
      return
    }
    const gesammtBreite = space - marqueeCutWitdthSidewall
    const maxBreite = marqueeMaxLength
    const anzahl = marqueeAmountComplete
    const check =
      ((polesTopNumber - 1) / anzahl) * SpaceBetweenBar < maxBreite
        ? (polesTopNumber - 1) / anzahl
        : (polesTopNumber - 1) / (anzahl + 1)
    const normal = Math.ceil(check) * SpaceBetweenBar
    const restSpace = gesammtBreite - normal * anzahl
    const start =
      Math.ceil(check) * SpaceBetweenBar +
      (restSpace > maxBreite ? Math.ceil(restSpace) * SpaceBetweenBar : 0)
    const restEndSpace = gesammtBreite - start
    const end =
      restEndSpace > maxBreite
        ? Math.ceil(check) * SpaceBetweenBar
        : restEndSpace
    const restSparren = polesTopNumber - 1 - Math.ceil(check) * 2
    const rest = gesammtBreite - (start + end)
    const checkRest = hasRoofBarCenter
      ? Math.ceil(rest / maxBreite)
      : restSparren - (anzahl - 2) > 0
      ? restSparren - (anzahl - 2)
      : 1
    const restArray =
      rest > maxBreite
        ? [...Array(checkRest)].map((_, i) => {
            if (hasRoofBarCenter) {
              return rest / Math.ceil(rest / maxBreite)
            } else {
              return i
                ? (rest / restSparren) * Math.ceil(rest / maxBreite)
                : rest / restSparren
            }
          })
        : [rest]
    marqueeStack.push(start)
    marqueeStack.push(...restArray)
    marqueeStack.push(end)
  }

  return {
    marqueeTyp,
    marqueeFabricColor,
    marqueeLength,
    getMarqueePosition,
    maqrueeAttributes,
    checkMarqueeAmount,
    marqueeStack,
    turningBox,
    hasSideWall,
  }
}
